<template>
  <div>
    <section class="section-b-space light-layout">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="success-text">
              <div class="checkmark">
                <svg class="star" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.296.747c.532-.972 1.393-.973 1.925 0l2.665 4.872 4.876 2.66c.974.532.975 1.393 0 1.926l-4.875 2.666-2.664 4.876c-.53.972-1.39.973-1.924 0l-2.664-4.876L.76 10.206c-.972-.532-.973-1.393 0-1.925l4.872-2.66L8.296.746z">
                  </path>
                </svg>
                <svg class="star" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.296.747c.532-.972 1.393-.973 1.925 0l2.665 4.872 4.876 2.66c.974.532.975 1.393 0 1.926l-4.875 2.666-2.664 4.876c-.53.972-1.39.973-1.924 0l-2.664-4.876L.76 10.206c-.972-.532-.973-1.393 0-1.925l4.872-2.66L8.296.746z">
                  </path>
                </svg>
                <svg class="star" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.296.747c.532-.972 1.393-.973 1.925 0l2.665 4.872 4.876 2.66c.974.532.975 1.393 0 1.926l-4.875 2.666-2.664 4.876c-.53.972-1.39.973-1.924 0l-2.664-4.876L.76 10.206c-.972-.532-.973-1.393 0-1.925l4.872-2.66L8.296.746z">
                  </path>
                </svg>
                <svg class="star" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.296.747c.532-.972 1.393-.973 1.925 0l2.665 4.872 4.876 2.66c.974.532.975 1.393 0 1.926l-4.875 2.666-2.664 4.876c-.53.972-1.39.973-1.924 0l-2.664-4.876L.76 10.206c-.972-.532-.973-1.393 0-1.925l4.872-2.66L8.296.746z">
                  </path>
                </svg>
                <svg class="star" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.296.747c.532-.972 1.393-.973 1.925 0l2.665 4.872 4.876 2.66c.974.532.975 1.393 0 1.926l-4.875 2.666-2.664 4.876c-.53.972-1.39.973-1.924 0l-2.664-4.876L.76 10.206c-.972-.532-.973-1.393 0-1.925l4.872-2.66L8.296.746z">
                  </path>
                </svg>
                <svg class="star" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.296.747c.532-.972 1.393-.973 1.925 0l2.665 4.872 4.876 2.66c.974.532.975 1.393 0 1.926l-4.875 2.666-2.664 4.876c-.53.972-1.39.973-1.924 0l-2.664-4.876L.76 10.206c-.972-.532-.973-1.393 0-1.925l4.872-2.66L8.296.746z">
                  </path>
                </svg>
                <svg v-if="[1,2,3].includes(trade.status)" class="checkmark__check" height="36" viewBox="0 0 48 36" width="48"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M47.248 3.9L43.906.667a2.428 2.428 0 0 0-3.344 0l-23.63 23.09-9.554-9.338a2.432 2.432 0 0 0-3.345 0L.692 17.654a2.236 2.236 0 0 0 .002 3.233l14.567 14.175c.926.894 2.42.894 3.342.01L47.248 7.128c.922-.89.922-2.34 0-3.23">
                  </path>
                </svg>
                <svg v-if="[1,2,3].includes(trade.status)" class="checkmark__background" height="115" viewBox="0 0 120 115" width="120" xmlns="http://www.w3.org/2000/svg">
                  <path d="M107.332 72.938c-1.798 5.557 4.564 15.334 1.21 19.96-3.387 4.674-14.646 1.605-19.298 5.003-4.61 3.368-5.163 15.074-10.695 16.878-5.344 1.743-12.628-7.35-18.545-7.35-5.922 0-13.206 9.088-18.543 7.345-5.538-1.804-6.09-13.515-10.696-16.877-4.657-3.398-15.91-.334-19.297-5.002-3.356-4.627 3.006-14.404 1.208-19.962C10.93 67.576 0 63.442 0 57.5c0-5.943 10.93-10.076 12.668-15.438 1.798-5.557-4.564-15.334-1.21-19.96 3.387-4.674 14.646-1.605 19.298-5.003C35.366 13.73 35.92 2.025 41.45.22c5.344-1.743 12.628 7.35 18.545 7.35 5.922 0 13.206-9.088 18.543-7.345 5.538 1.804 6.09 13.515 10.696 16.877 4.657 3.398 15.91.334 19.297 5.002 3.356 4.627-3.006 14.404-1.208 19.962C109.07 47.424 120 51.562 120 57.5c0 5.943-10.93 10.076-12.668 15.438z">
                  </path>
                </svg>
              </div>
              <div v-if="ticket_id.length === 36">
                <div v-if="trade.status === 0">
                  <h2>即将开始支付</h2>
                  <p></p>
                  <p class="font-weight-bold">Transaction ID: {{ ticket_id }}</p>
                  <p class="font-weight-bold" v-if="ticket.express.country">国家: {{ ticket.express.country }}</p>
                  <p class="font-weight-bold" v-if="ticket.express.lastname">收货人: {{ ticket.express.lastname }}**</p>
                  <p class="font-weight-bold" v-if="ticket.express.mobile_code">手机号: {{ ticket.express.mobile_code }} - {{ ticket.express.mobile }}</p>
                  <p class="font-weight-bold" v-if="ticket.amount !== trade.price">
                    支付金额: ￥{{ trade.price | number('0,0.00') }}元 <del>￥{{ ticket.amount | number('0,0') }}元</del>
                  </p>
                  <p class="font-weight-bold" v-else>
                    支付金额: ￥{{ ticket.amount | number('0,0.00') }}元
                  </p>
                  <div v-html="payContent"></div>
                  <a class="btn-solid btn" @click="confirm">确认支付</a>
                </div>
                <div v-else-if="trade.status === 1">
                  <h2>支付成功</h2>
                </div>
                <div v-else-if="trade.status === 2">
                  <h2>订单已发货</h2>
                </div>
                <div v-else-if="trade.status === 3">
                  <h2>订单已完成</h2>
                </div>
                <div v-else>
                  <h2>订单状态不可支付，如有疑问请联系客服</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {pay} from '@/api/trade'

var mobile = require('is-mobile')

export default {
  name: 'Pay',
  data () {
    return {
      ticket_id: '',
      is_mobile: mobile(),
      payContent: '',
      ticket: {
        express: {
          lastname: '',
          country: '',
          mobile_code: '',
          mobile: ''
        },
        cart: [],
        amount: 0
      },
      trade: {
        trade_id: '',
        status: '',
        price: ''
      }
    }
  },
  methods: {
    pay () {
      pay({
        ticket_id: this.ticket_id,
        is_mobile: mobile()
      }).then(res => {
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        this.payContent = res.result.content
        this.ticket = res.result.ticket
        this.trade = res.result.trade
      })
    },
    confirm () {
      document.forms['alipay_submit'].submit()
    }
  },
  mounted () {
    this.ticket_id = this.$route.params.ticket_id
    if (this.ticket_id.length === 36) {
      this.pay()
    } else {
      this.$message.info('订单号异常')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pay.vue